import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWho = ['Dueños de perros que sufren de dermatitis, alergias estacionales o alergia alimentaria.', 'Aquellos que están cansados de gastar cientos de dólares en soluciones temporales.', 'Personas que buscan una alternativa natural y basada en la biología para mejorar la vida de su mascota.', 'Dueños de perros con mal olor recurrente, lamer de patas u orejas inflamadas.'];
const notForWho = ['Personas que buscan una pastilla mágica para no tener que cocinar ni cambiar hábitos.', 'Dueños que no están dispuestos a seguir un protocolo estricto de 14 días.', 'Quienes prefieren soluciones químicas rápidas a pesar de los efectos secundarios.'];
export function TargetAudience() {
  return <section className="py-24 bg-white" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-125">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-forest-50 rounded-3xl p-8 md:p-12 border border-forest-100" data-id="element-126">
            <h3 className="text-2xl md:text-3xl font-bold text-forest mb-8" data-id="element-127">
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-128">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-129">
                  <CheckCircle2 className="w-6 h-6 text-forest shrink-0 mt-1" data-id="element-130" />
                  <span className="text-charcoal-600 text-lg" data-id="element-131">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-rust-50 rounded-3xl p-8 md:p-12 border border-rust-100" data-id="element-132">
            <h3 className="text-2xl md:text-3xl font-bold text-rust-700 mb-8" data-id="element-133">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-134">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-135">
                  <XCircle className="w-6 h-6 text-rust shrink-0 mt-1" data-id="element-136" />
                  <span className="text-charcoal-600 text-lg" data-id="element-137">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}